// Global variable for template name
let currentTemplate = document.body.getAttribute('data-template');

// Read More button(description) on product page for mobile view
if (currentTemplate == 'product' ){
  if (screen.width < 750){
    const ellipsisContainer = document.querySelector('.product__description p');
    const fullText = ellipsisContainer.textContent;
    const truncatedText = fullText.slice(0, 120) + '...';
    
    ellipsisContainer.textContent = truncatedText;
    
    const readMoreButton = document.createElement('span');
    readMoreButton.textContent = 'Read More';
    readMoreButton.classList.add('readmore');
    ellipsisContainer.insertAdjacentElement("afterend", readMoreButton);
    
    readMoreButton.addEventListener('click', () => {
      if (ellipsisContainer.textContent === truncatedText) {
        ellipsisContainer.textContent = fullText;
        readMoreButton.textContent = 'Read Less';
      } else {
        ellipsisContainer.textContent = truncatedText;
        readMoreButton.textContent = 'Read More';
      }
    });
  };
};
if (currentTemplate == 'product.pillow' || currentTemplate == 'product.accessories'){
  if (screen.width < 750){
    const ellipsisContainer = document.querySelector('.product__description');
    const fullText = ellipsisContainer.textContent;
    const truncatedText = fullText.slice(0, 120) + '...';
    
    ellipsisContainer.textContent = truncatedText;
    
    const readMoreButton = document.createElement('span');
    readMoreButton.textContent = 'Read More';
    readMoreButton.classList.add('readmore');
    ellipsisContainer.insertAdjacentElement("afterend", readMoreButton);
    
    readMoreButton.addEventListener('click', () => {
      if (ellipsisContainer.textContent === truncatedText) {
        ellipsisContainer.textContent = fullText;
        readMoreButton.textContent = 'Read Less';
      } else {
        ellipsisContainer.textContent = truncatedText;
        readMoreButton.textContent = 'Read More';
      }
    });
  };
};

if (currentTemplate == 'collection'){

  const descriptionElement = document.querySelector('.card-product_description');
  
  if (descriptionElement) {
    const anchorTags = document.querySelectorAll('.card-product_description a');
    anchorTags.forEach(anchor => {
      const span = document.createElement('span');
      for (const attr of anchor.attributes) {
        span.setAttribute(attr.name, attr.value);
      }
      span.innerHTML = anchor.innerHTML;
      anchor.parentNode.replaceChild(span, anchor);
    });
  }
}
